import { autopayStatusUrl } from "./endpoints.js";
const autopayStatusCacheKey = ({
  accountId,
  accountIdType
}) => [autopayStatusUrl, { accountId, accountIdType }];
export {
  autopayStatusCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
